import ComponentEx from 'components/ComponentEx';
import { getTxt } from 'global/appGlobal';
import { Dialog, DialogContent } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose, graphql } from 'react-apollo';
import LinearProgressEx from '../../components/LinearProgressEx';
import c from '../../components/form/Components';
import MaterialForm from '../../components/form/MaterialForm';
import { DictionaryTypes, getDictionary, getLabel } from '../../global/dictionaryCache';
import { metadataQuery } from '../../home/Home';
import Custom_Fields_Edit from '../../modules/publicInsType/Custom_Fields_Edit';
import * as queries from '../../modules/publicInsType/publicInsTypeQueries';
import { publicPaymentTypeByIdQuery, updatePublicPaymntTypeMutation, allPaymentTypesQuery } from './paymentTypeQueries';

let history;
let AfterSubmit;

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing.unit * 2,
        margin: theme.spacing.unit * 2,
    },
});


class PublicPaymentTypeEdit extends ComponentEx {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.formChanged = this.formChanged.bind(this);
    }

    state = {
        open: false,
    };

    formSetValues = { func: undefined };

    formChanged(field, value, type, prevVal) {
    }

    onSubmit(e, { obj, showErrors, hideErrors }) {
        const original = this.props.data.publicPaymentTypeById;
        obj.public_payment_type_id = original.public_payment_type_id;

        this.props.updateType({
            variables: { type: obj },
            refetchQueries: [
                {
                    query: allPaymentTypesQuery,
                },
                {
                    query: publicPaymentTypeByIdQuery,
                    variables: { id: original.public_payment_type_id },
                },
                {
                    query: metadataQuery,
                },
            ],
        }, this).then(
            (resp) => {
                hideErrors();
                if (resp.data.updatePublicPaymntType &&
                    resp.data.updatePublicPaymntType.validation &&
                    resp.data.updatePublicPaymntType.validation.length > 0) {
                    showErrors(resp.data.updatePublicPaymntType.validation);
                } else {
                    if (!AfterSubmit) {
                        history.goBack();
                    } else {
                        AfterSubmit(resp.data.updatePublicPaymntType.id);
                    }
                }
            });
    }

    render() {

        const { classes } = this.props;

        const loading = this.props.data.loading;
        const item = this.props.data.publicPaymentTypeById;
        history = this.props.history;
        AfterSubmit = this.props.AfterSubmit;
        let caption;


        if (item && item.public_payment_type_id === '-1') {
            caption = getTxt('Nuovo Payment Type');
        } else {
            caption = getTxt('Modifica Payment Type');
        }

        return (


            <Dialog onClose={() => { this.props.AfterSubmit(); }} open >
                <DialogContent>
                    <LinearProgressEx loading={loading} />


                    <Typography variant="h4" color="inherit" noWrap={false}>{caption}</Typography>


                    {item &&

                        <MaterialForm
                            dataSource={item}
                            objType="public_payment_type"
                            onSubmit={this.onSubmit}
                            onChange={this.formChanged}
                            setValues={this.formSetValues}
                        >

                            
                            <c.field l={getTxt('Actual Payment Type')} f="real_payment_type_value" ui="select" d={item.public_payment_type_id !== '-1'} >
                                {getDictionary(DictionaryTypes.PaymentType)}
                            </c.field>

                            <c.field f="value" l={getTxt('Payment Type Key')} />
                            <c.field f="label" l={getTxt('Payment Type Name')} />

                            <c.formButtons sm={12} onCancel={() => { this.props.AfterSubmit(); }} />
                        </MaterialForm>


                    }

                </DialogContent>

            </Dialog>

        );
    }
}

export default compose(
    graphql(publicPaymentTypeByIdQuery, {
        options: props => (
            {
                variables: {
                    id: props.id,
                },
                fetchPolicy: 'network-only',
                errorPolicy: 'all',
            }
        ),
    }),
    graphql(updatePublicPaymntTypeMutation, {
        name: 'updateType',
        options: {
            errorPolicy: 'all',
           
        },
    }),
)(withStyles(styles)(PublicPaymentTypeEdit));
